<template>
	<div class="sidebar-container">
		<div class="ks-panel">
			<div class="ks-panel-heading">
				<div class="ks-panel-title">
					<template v-if="icon">
						<k-icon small>{{icon}}</k-icon>
					</template>
					<span class="ml-2">
						{{title}}
					</span>
				</div>
				<div class="ks-panel-left-buttons">
					<slot name="leftbuttons"></slot>
				</div>
				<div class="ks-panel-buttons">
		 			<slot name="buttons"></slot>
		 		</div>
			</div>

			<div>
				<div v-if="search" style="padding-left: 3px; padding-right: 3px; margin-bottom: 3px; margin-top: 3px; ">
					<k-text-field
	        			placeholder="Search"
	        			prepend-icon="search"
	        			:loading="searchLoading"
						hide-details
						clearable
						v-model="search_text">						
					</k-text-field>
				</div>

	    	<div v-if="is_subheader">
		    	<slot name="subheader"></slot>
	   		</div>
	   		<div v-if="is_twosubheader">
	    		<slot name="twosubheader"></slot>
	  		</div>

			</div>

			<div class="ks-panel-body">
				<slot></slot>
			</div>

		</div>
	</div>
</template>

<script>
export default {
	props: {
		"title": {
			type: String,
			default: ""
		},
		"icon": {
			type: String
		},
		"search": {
			type: Boolean,
			default: false
		},
		"searchLoading": {
			type: Boolean,
			default: false
		},
		"value": {
			type: String,
			default: ""
		}
	},
	watch: {
		"search_text": function(newVal, oldVal) {
			this.$emit("input", newVal);
		},
		"value": function(newVal, oldVal) {
			this.search_text = newVal;
		}
	},
	data() {
		return {
			is_subheader: false,
			is_twosubheader: false,
			is_header: false,
			search_text: this.value
		}
	},
	mounted() {
		if (typeof(this.$slots.subheader) != "undefined") {
			this.is_subheader = true;
		}
		if (typeof(this.$slots.twosubheader) != "undefined") {
			this.is_twosubheader = true;
		}


		if (typeof(this.$slots.header) != "undefined") {
			this.is_header = true;
		}
	}

}
</script>

<style scoped>
.sidebar-container .ks-panel {
	display: grid; 
	grid-template-rows: max-content max-content 1fr; 
	height: 100%;
	width: 100%;
	max-width: 100%;
	border: 1px solid var(--ks-col-secondary);
	overflow: hidden;
}
.sidebar-container .ks-panel-body {
	width: 100%;
}

.sidebar-container .ks-panel-body {
	overflow-y: auto; 
	height: 100%;
}
.sidebar-container .ks-panel-title i {
	margin-right: 10px;
}

.sidebar-container {
	position: absolute;
	flex-grow: 1;
	width: 100%;
	top: 0px;
	bottom: var(--ks-margin-1);
}

.with_subheader {
/*	margin-top: 50px; */
}
.with_twosubheader {
/*	margin-top: 100px;*/
}
</style>
